import Button from "components/Buttons/Button";
import Render from "components/Common/Render";

interface IPreregisterButtons {
  isPreRegistered: boolean;
  isCancellingRegistration: boolean;
  onContinue: () => void;
  buttonStyle: string;
  onCancelRegistration: () => void;
}
const PreRegisterButtons = ({
  isPreRegistered,
  isCancellingRegistration,
  onContinue,
  buttonStyle,
  onCancelRegistration,
}: IPreregisterButtons) => {
  return (
    <div className="flex flex-col  md:flex-row-reverse w-[100%] px-2">
      <Button
        disabled={isPreRegistered}
        label={isPreRegistered ? "Registered" : "Continue"}
        onClick={onContinue}
        customClass={buttonStyle}
      />
      <Render when={isPreRegistered}>
        <Button
          variant="secondary"
          loading={isCancellingRegistration}
          label="Cancel Registration"
          onClick={() => onCancelRegistration()}
          customClass={`${buttonStyle} !border-none !font-light`}
        />
      </Render>
    </div>
  );
};

export default PreRegisterButtons;
